import { useParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";
import { PitchDeckGenerator } from "@/components/PitchDeckGenerator";

export const PitchDeckPage = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();

  if (!projectId) {
    return <div className="text-center p-12 text-slate-500">Project ID not found</div>;
  }

  return (
    <div className="w-full h-full">
      <PitchDeckGenerator projectId={projectId} />
    </div>
  );
};